import { render } from "./PayoutsList.vue?vue&type=template&id=055ff87a"
import script from "./PayoutsList.vue?vue&type=script&lang=js"
export * from "./PayoutsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__